import React from 'react';
import Hightcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

const ChartStackedGroupColumn = ({chartData, title}) => {
	if (chartData == undefined || chartData.length == 0) {
		return
	}

	const optionsBar = {
		chart: {
			type: 'column'
		},
	
		title: {
			text: title,
			style: {
			  color: '#000',
			  fontSize: "14px",
			  fontWeight: "bold",
			}		
		},
	
		xAxis: {
			categories: chartData[0].cat
		},
	
		yAxis: {
			allowDecimals: false,
			min: 0,
			title: {
				text: '매출액'
			}
		},
	
		tooltip: {
			formatter: function () {
				return '<b>' + this.x + '</b><br/>' +
					this.series.name + ': ' + this.y + '<br/>' +
					'Total: ' + this.point.stackTotal;
			}
		},
	
		plotOptions: {
			column: {
				stacking: 'normal'
			}
		},
	
		series: chartData
	};

	return (
		<>
			<HighchartsReact highcharts={Hightcharts} options={optionsBar} />
		</>
	);
};

export default ChartStackedGroupColumn;